import React from "react";
import styled from "styled-components";
import { includeStyledSystem, sx } from "../util/styledSystem";
export const getVariants = ({ space, fonts, fontSizes, colors: { textColors } }) => ({
    base: {
        fontFamily: fonts.main,
        fontSize: fontSizes[1],
    },
    button: {
        fontSize: fontSizes[1],
        fontWeight: 400,
    },
    cardHeading: {
        color: textColors.cardHeading,
        fontSize: fontSizes[3],
        fontWeight: "lighter",
        letterSpacing: "1px",
        textTransform: "uppercase",
    },
    cardHeadingCount: {
        color: textColors.cardHeadingCount,
        fontSize: "21px",
        fontWeight: 400,
        textTransform: "uppercase",
    },
    critical: {
        color: textColors.critical,
        fontWeight: 700,
    },
    detailsArea: {
        color: textColors.detailsArea,
        fontSize: "20px",
        letterSpacing: "1px",
        textTransform: "uppercase",
    },
    emergency: {
        color: textColors.emergency,
        fontWeight: 700,
    },
    formHeading: {
        fontSize: fontSizes[4],
        fontWeight: 700,
    },
    greyIcon: {
        // Disabled has to override over state
        "&&:disabled": {
            color: textColors.greyIconDisabled,
        },
        "&:hover": {
            color: textColors.greyIconHover,
        },
        color: textColors.greyIcon,
    },
    greyLink: {
        "&:hover": {
            color: textColors.greyLinkHover,
            textDecoration: "underline",
        },
        color: textColors.greyLink,
        cursor: "pointer",
        fontSize: fontSizes[1],
        textDecoration: "none",
        weight: "normal",
    },
    header: {
        color: textColors.header,
        fontFamily: fonts.main,
        fontSize: "20px",
        fontWeight: 600,
    },
    informational: {
        color: textColors.informational,
        fontWeight: 400,
    },
    label: {
        fontSize: fontSizes[1],
        fontWeight: 700,
    },
    link: {
        "&:hover": {
            textDecoration: "underline",
        },
        color: textColors.link,
        cursor: "pointer",
        fontSize: fontSizes[1],
        textDecoration: "none",
        weight: "normal",
    },
    paragraph: {
        "& a": {
            color: textColors.link,
            cursor: "pointer",
        },
        display: "block",
        marginBottom: space[2],
    },
    subTitle: {
        color: textColors.subTitle,
        display: "block",
        fontSize: fontSizes[1],
        marginBottom: space[2],
        marginTop: space[1],
    },
    warning: {
        color: textColors.warning,
        fontWeight: 400,
    },
    whiteIcon: {
        // Disabled has to override over state
        "&&:disabled": {
            color: textColors.whiteIconDisabled,
        },
        "&:hover": {
            color: textColors.whiteIconHover,
        },
        color: textColors.whiteIcon,
    },
});
const DEFAULT_TEXT_STYLE = "base";
export const Text = styled.div `
  min-width: 0;
  display: inline;
  box-sizing: border-box;
  ${({ theme }) => ({
    color: theme.colors.textColors.default,
    fontFamily: theme.fonts.main,
    letterSpacing: "normal",
    lineHeight: "normal",
})}

  ${({ theme, textStyle = DEFAULT_TEXT_STYLE }) => (Object.assign({}, getVariants(theme)[textStyle]))}

  ${includeStyledSystem()}
  ${sx}
`;
Text.defaultProps = {
    "data-testid": "text",
    textStyle: DEFAULT_TEXT_STYLE,
};
export const FormHeading = (props) => React.createElement(Text, Object.assign({ "data-testid": "formHeading", textStyle: "formHeading" }, props));
export const SubTitle = (props) => React.createElement(Text, Object.assign({ "data-testid": "subTitle", textStyle: "subTitle" }, props));
export const Label = (props) => React.createElement(Text, Object.assign({ as: "label", "data-testid": "label", textStyle: "label" }, props));
/**
 * A shortcut to use the Link variant.
 */
export const Link = (props) => React.createElement(Text, Object.assign({ as: "a", textStyle: "link" }, props));
/**
 * Paragraphs are used to display a Paragraph of text.
 */
export const Paragraph = (props) => React.createElement(Text, Object.assign({ as: "p", textStyle: "paragraph" }, props));
